import { selectIsMatched, selectMember } from 'logic/member';

export const CardBadgeFlame = {
  bindings: {
    tags: '<',
  },

  template: `
    <card-badge
      icon="icon-voome-flame"
      ng-if="$ctrl.isMatched">
    </card-badge>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const { member } = $ngRedux.getState();
        this.isMatched = selectIsMatched(member, this.tags);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Card/CardBadgeFlame.js